import { assignInlineVars } from "@vanilla-extract/dynamic";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { ComplianceCaseResolution, ComplianceCaseStatus } from "~/graphql/supergraphEnums";
import { resolutionStyle, resolutionTextColor, resolutionWrapper } from "./styles_vanilla.css";
import { getDisplayInfo } from "./utils";

export const ResolutionRenderer = ({
  resolution,
  status,
  internal = false,
}: {
  resolution: ComplianceCaseResolution | string | null | undefined;
  status?: ComplianceCaseStatus | string | null;
  /** Internal escalation (entity/client onboarding subject): verdict wording without the GP. */
  internal?: boolean;
}) => {
  const {
    displayText,
    iconType,
    iconColor = Colors.Neutral900,
  } = getDisplayInfo(resolution, status, internal) || {};
  return (
    <Flex alignItems="center" gap={8} className={resolutionWrapper}>
      {iconType && (
        <Icon
          type={iconType}
          color={iconColor}
          data-testid="case-resolution-icon"
          data-cy="case-resolution-icon"
        />
      )}
      <Text
        data-testid="case-resolution-label"
        data-cy="case-resolution-label"
        style={assignInlineVars({
          [resolutionTextColor]: iconColor,
        })}
        className={resolutionStyle}
      >
        {displayText}
      </Text>
    </Flex>
  );
};
